const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export function Login() {
  const handleLogin = () => {
    window.location.href = `${API_BASE_URL}/api/auth/login`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full space-y-8 p-8 bg-white rounded-lg shadow">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-gray-900">Voice Journal</h2>
          <p className="mt-2 text-gray-600">Sign in to access your journal</p>
        </div>
        <button
          onClick={handleLogin}
          className="w-full flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 transition-colors"
        >
          Sign in with Google
        </button>
      </div>
    </div>
  );
}
